import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";
import DeliverySection from "./DeliverySection";
import Select from "react-select";
import JoditEditor from "jodit-react";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [dataUsers, setData] = useState({});
  const GetEditData = async () => {
    const response = await getData(`/admin/subscription/appointment/${id}`);
    reset(response?.data);
    setData(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    trigger,
    watch,
    setValue,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      // DataToSend.append("name", data.name);
      // DataToSend.append("sub_name", data.sub_name);
      // DataToSend.append("term_condition", data.term_condition);
      // if (data.plan_feture_id) {
      //   DataToSend.append(
      //     "plan_feture_id",
      //     JSON.stringify(data.plan_feture_id.map((option) => option.value))
      //   );
      // }

      // if (data?.image?.length > 0) {
      //   DataToSend.append("image", data.image[0]);
      // }

      // // Intake Direction
      // const intake_direction = [];
      // data.intake_direction?.forEach((item, index) => {
      //   intake_direction.push({
      //     id:item.id,
      //     name: item.name,
      //     sub_name: item.sub_name,
      //   });

      //   if (item.image[0] instanceof File) {
      //     DataToSend.append(`intake_image${index}`, item.image[0]);
      //   }
      // });
      // DataToSend.append("intake_direction", JSON.stringify(intake_direction));

      // // Nutritions
      // const nutritions =
      //   data.nutritions?.map((item) => ({ name: item.name })) || [];
      // DataToSend.append("nutritions", JSON.stringify(nutritions));

      // // Plan Prices
      // const plan_price =
      //   data.plan_price?.map((item) => ({
      //     duration: item.duration,
      //     price: item.price,
      //   })) || [];
      // DataToSend.append("plan_price", JSON.stringify(plan_price));

      // Weeks + Deliveries
      // const weeks = [];
      // data.weeks?.forEach((week, wIndex) => {
      //   const weekObj = {
      //     week_id: week.week_id,
      //     appointment_id: dataUsers?.id,
      //     days_id: week.days_id?.map((day) => day.value) || [],
      //     deliveries: [],
      //   };

      //   week.deliveries?.forEach((delivery, dIndex) => {
      //     weekObj.deliveries.push({
      //       week_id: week.week_id,
      //       appointment_id: dataUsers?.id,
      //       category_id: dataUsers?.category_id,
      //       product_id: delivery.product_id?.value,
      //       quantity: delivery.quantity,
      //       calories: delivery.calories,
      //       serving_size: delivery.serving_size,
      //     });
      //   });

      //   weeks.push(weekObj);
      // });
      // DataToSend.append("weeks", JSON.stringify(weeks));

      const weeks = [];

      data.weeks?.forEach((week) => {
        const weekObj = {
          week_id: week.week_id,
          appointment_id: dataUsers?.id,
          deliveries: [],
        };

        week.deliveries?.forEach((delivery) => {
          const deliveryObj = {
            appointment_id: dataUsers?.id,
            week_id: week.week_id,
            delivery_id: delivery.delivery_id,
            days_id: delivery.days_id?.map((day) => day.value) || [],
            products: [],
          };

          delivery.products?.forEach((product) => {
            deliveryObj.products.push({
              appointment_id: dataUsers?.id,
              week_id: week.week_id,
              delivery_id: delivery.delivery_id,
              id: product.product_id,
              category_id: product.category_id?.value,
              product_id: product.product_id?.value,
              quantity: product.quantity,
              calories: product.calories,
              serving_size: product.serving_size,
            });
          });

          weekObj.deliveries.push(deliveryObj);
        });

        weeks.push(weekObj);
      });

      DataToSend.append("weeks", JSON.stringify(weeks));
      const response = await putData(
        `/admin/subscription/appointment/${id}`,
        DataToSend
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "plan_price",
  });

  const {
    fields: weekFields,
    append: appendWeek,
    remove: removeWeek,
  } = useFieldArray({
    control,
    name: "weeks",
  });
  const {
    fields: intakeDirectionFields,
    append: appendIntakeDirection,
    remove: removeIntakeDirection,
  } = useFieldArray({
    control,
    name: "intake_direction",
  });

  const {
    fields: nutritionFields,
    append: appendNutrition,
    remove: removeNutrition,
  } = useFieldArray({
    control,
    name: "nutritions",
  });
  const [days, setDays] = useState([]);
  const getAllDays = async () => {
    const response = await getData("/common/masters/all-days");
    if (response?.success) {
      setDays(await Select2Data(response?.data, "day_id"));
    }
  };

  const [planFeture, setPlanFeture] = useState([]);
  const getPlanFeture = async () => {
    const response = await getData("/common/masters/all-plan-feture");
    if (response?.success) {
      setPlanFeture(await Select2Data(response?.data, "plan_feture_id"));
    }
  };
  useEffect(() => {
    getAllDays();
    getPlanFeture();
  }, []);

  const [imagePreviewsvarient, setImagePreviewsVarient] = useState([]);
  const handlevarientImageChange = (e, index) => {
    const files = Array.from(e.target.files);
    if (files.length) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewsVarient((prevPreviews) => {
          const newPreviews = [...prevPreviews];
          newPreviews[index] = reader.result;
          return newPreviews;
        });
      };
      reader.readAsDataURL(files[0]);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Appointment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Category Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        disabled
                        placeholder="Plan Name..."
                        value={dataUsers?.p_category?.name}
                      // className={classNames("", {
                      //   "is-invalid": errors?.sub_name,
                      // })}
                      // {...register("sub_name", {
                      //   required: "Plan Sub Name is required",
                      // })}
                      />
                    </InputGroup>
                    {errors.sub_name && (
                      <span className="text-danger">
                        {errors.sub_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6> Weeks</h6>

                  <div className="package-details-section">
                    {weekFields.map((week, index) => (
                      <div key={week.id} className="mb-4 p-3 border">
                        <h5>Week {index + 1}</h5>

                        <DeliverySection
                          data={dataUsers}
                          weekIndex={index}
                          control={control}
                          register={register}
                          getValues={getValues}
                          errors={errors}
                          setValue={setValue}
                        />
                        <button
                          type="button"
                          className="add-varient  mt-3 mx-2"
                          onClick={() => removeWeek(index)}
                        >
                          Remove Week
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient mt-3"
                  onClick={() =>
                    appendWeek({ deliveries: [{ duration: "", price: "" }] })
                  }
                >
                  + Add Week
                </button>
              </div>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
